import React from 'react';
import { StarIcon } from 'lucide-react';
export const SidebarCTA = () => {
  return <div className="bg-white rounded-lg border border-gray-200 shadow-md p-4" data-id="element-227">
      <div className="text-center mb-4" data-id="element-228">
        <div className="mx-auto rounded-lg w-full max-w-[200px] mb-3 h-[200px] overflow-hidden" data-id="element-229">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nzccB55Dtx1Eo9gAabPjFB/ChatGPTImage1_2025_05_44_00_._..png" alt="Glisera Anti-Cellulite Oil bottle with pump dispenser" className="w-full h-full object-contain" data-id="element-230" />
        </div>
      </div>
      <h3 className="text-xl font-bold text-center mb-2" data-id="element-231">
        Glisera Restore & Firm Oil
      </h3>
      <div className="mb-4" data-id="element-232">
        <h4 className="text-base font-bold mb-2" data-id="element-233">Customer Reviews</h4>
        <div className="flex items-center mb-1" data-id="element-234">
          <div className="flex items-center" data-id="element-235">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-500 fill-yellow-500" size={14} data-id="element-236" />)}
          </div>
          <span className="ml-2 text-sm" data-id="element-237">
            <span className="font-bold" data-id="element-238">4.8 out of 5</span>
          </span>
        </div>
        <div className="text-sm text-gray-600 mb-3" data-id="element-239">2,471 customer ratings</div>
        <div className="space-y-1" data-id="element-240">
          <div className="flex items-center" data-id="element-241">
            <span className="w-10 text-sm" data-id="element-242">5 Star</span>
            <div className="flex-1 mx-2 h-4 bg-gray-200 rounded-sm" data-id="element-243">
              <div className="h-full bg-yellow-400 rounded-sm" style={{
              width: '90%'
            }} data-id="element-244"></div>
            </div>
            <span className="w-8 text-right text-sm" data-id="element-245">90%</span>
          </div>
          <div className="flex items-center" data-id="element-246">
            <span className="w-10 text-sm" data-id="element-247">4 Star</span>
            <div className="flex-1 mx-2 h-4 bg-gray-200 rounded-sm" data-id="element-248">
              <div className="h-full bg-yellow-400 rounded-sm" style={{
              width: '7%'
            }} data-id="element-249"></div>
            </div>
            <span className="w-8 text-right text-sm" data-id="element-250">7%</span>
          </div>
          <div className="flex items-center" data-id="element-251">
            <span className="w-10 text-sm" data-id="element-252">3 Star</span>
            <div className="flex-1 mx-2 h-4 bg-gray-200 rounded-sm" data-id="element-253">
              <div className="h-full bg-yellow-400 rounded-sm" style={{
              width: '2%'
            }} data-id="element-254"></div>
            </div>
            <span className="w-8 text-right text-sm" data-id="element-255">2%</span>
          </div>
          <div className="flex items-center" data-id="element-256">
            <span className="w-10 text-sm" data-id="element-257">2 Star</span>
            <div className="flex-1 mx-2 h-4 bg-gray-200 rounded-sm" data-id="element-258">
              <div className="h-full bg-yellow-400 rounded-sm" style={{
              width: '0%'
            }} data-id="element-259"></div>
            </div>
            <span className="w-8 text-right text-sm" data-id="element-260">0%</span>
          </div>
          <div className="flex items-center" data-id="element-261">
            <span className="w-10 text-sm" data-id="element-262">1 Star</span>
            <div className="flex-1 mx-2 h-4 bg-gray-200 rounded-sm" data-id="element-263">
              <div className="h-full bg-yellow-400 rounded-sm" style={{
              width: '1%'
            }} data-id="element-264"></div>
            </div>
            <span className="w-8 text-right text-sm" data-id="element-265">1%</span>
          </div>
        </div>
      </div>
      <div className="bg-green-100 text-green-800 text-sm text-center p-2 rounded-md mb-4" data-id="element-266">
        LIMITED TIME OFFER + FREE SHIPPING
      </div>
      <a href="https://www.tryglisera.com/products/glisera-anti-cellulite-oil" target="_blank" rel="noopener noreferrer" className="block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-md shadow-lg transition duration-300 text-lg w-full uppercase text-center" data-id="element-267">
        Apply Discount & Check Availability
      </a>
      <div className="mt-3 text-center text-xs text-gray-500" data-id="element-268">
        30-Day Money-Back Guarantee
      </div>
    </div>;
};